module.exports = __webpack_public_path__ + "static/media/DSCF9536.92118761.jpg";